export type VerifyQuoteType = "data" | "otp";

export interface QuoteVerifyInitResponse {
  uniqueKey?: string;
  destCurrency?: string;
  userSend?: number;
  conversionRate?: number;
  recipientRecieve?: number;
  totalPay?: number;
  transactionPurpose?: string;
  email?: string;
  sendType?: "email" | "sms" | string;
  smsType?: "email" | "sms" | string;
  quoteVerified: boolean;
  linkExpired: boolean;
  expiredOn?: string;
  otpSent: boolean;
  message?: string | null;
  maskedContact?: string;
  totalTax?: number;
  taxes?: number;
  gst?: number;
  tcs?: number;
  nostro?: number;
  nostroCharges?: number;
  nostro_charges_new?: number;
  nostroChargesNew?: number;
  hopFees?: number;
  vendorFee?: number;
  hop_fees?: number;
  bankFee?: number;
  nostro_charges?: number;
  quoteVerifiedDate?: string;
  createdOn?: string;
}

export interface QuoteVerifyOtpResponse {
  uniqueKey: string;
  quoteVerified: boolean;
  quoteVerifiedDate?: string;
  createdOn?: string;
  destCurrency?: string;
  userSend?: number;
  totalPay?: number;
}

export interface ResendOtpResponse {
  success: boolean;
  message: string;
}

export const hasQuoteSummaryData = (quote: QuoteVerifyInitResponse) =>
  Boolean(
    quote.destCurrency ||
      quote.userSend !== undefined ||
      quote.totalPay !== undefined ||
      quote.conversionRate !== undefined
  );
